import React from 'react'

import { parseUserAgent } from '@/shared/lib/user-agent'

export function useSafariWebPCompatibility() {
    // Note: by default, we assume that browser supports webp and even if it doesn't, we will provide png fallback
    const [isWebPSupported, setIsWebPSupported] = React.useState(true)

    React.useEffect(() => {
        const userAgent = parseUserAgent()

        const isSafari = userAgent.browser.name === 'Safari' || userAgent.browser.name === 'Mobile Safari'
        const majorVersion = userAgent.browser.major

        if (isSafari && majorVersion && Number(majorVersion) < 16) {
            setIsWebPSupported(false)
        }
    }, [])

    return isWebPSupported
}
